import styled from 'styled-components';

export const Sections = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
`;
